export default (
  state = {
    general: [],
    payments: [],
    delivery: []
  },
  action
) => {
  switch (action.type) {
    case "FETCH_USP_SUCCESS":
      return {
        ...state,
        general: action.payload.product_page_general || [],
        payments: action.payload.product_page_payments || [],
        delivery: action.payload.product_page_delivery || [],
      };
      break;
    case "FETCH_USP_ERROR":
      return {
        ...state,
        uspError: true,
      };
      break;
    default:
      return state;
  }
};
